import { cloneDeep } from 'lodash'

import API from '../api/api'

const SET_CONVERSATIONS = 'SET_CONVERSATIONS'
const SET_CHAT_CONTACTS = 'SET_CHAT_CONTACTS'
const ADD_UNREAD_CONVERSATIONS = 'ADD_UNREAD_CONVERSATIONS'
const REMOVE_UNREAD_CONVERSATIONS = 'REMOVE_UNREAD_CONVERSATIONS'
const REMOVE_ALL_UNREAD_CONVERSATIONS = 'REMOVE_ALL_UNREAD_CONVERSATIONS'
const ADD_CLOSED_CONVERSATIONS = 'ADD_CLOSED_CONVERSATIONS'
const REMOVE_CLOSED_CONVERSATIONS = 'REMOVE_CLOSED_CONVERSATIONS'
const ADD_ASSIGNED_CONVERSATIONS = 'ADD_ASSIGNED_CONVERSATIONS'
const REMOVE_ASSIGNED_CONVERSATIONS = 'REMOVE_ASSIGNED_CONVERSATIONS'
const SET_CHAT_INBOX = 'SET_CHAT_INBOX'
const SET_CUSTOM_CHAT_INBOX = 'SET_CUSTOM_CHAT_INBOX'
const SET_INVOICES = 'SET_INVOICES'
const UPDATE_CHAT_INBOX = 'UPDATE_CHAT_INBOX'
const SET_BUILDING_SMS_PACK = 'SET_BUILDING_SMS_PACK'
const SET_LOADING_MESSAGES = 'SET_LOADING_MESSAGES'
const SET_LOADING_CONVERSATIONS = 'SET_LOADING_CONVERSATIONS'
const UPDATE_CONVERSATION_OR_ADD = 'UPDATE_CONVERSATION_OR_ADD'
const ADD_CONVERSATION = 'ADD_CONVERSATION'
const SET_HIGH_MANAGEMENT_USERS = 'SET_HIGH_MANAGEMENT_USERS'
const SET_VOICEMAIL_MESSAGES = 'SET_VOICEMAIL_MESSAGES'
const REMOVE_VOICEMAIL_MESSAGE = 'REMOVE_VOICEMAIL_MESSAGE'
const ADD_VOICEMAIL_MESSAGE = 'ADD_VOICEMAIL_MESSAGE'
const UPDATE_VOICEMAIL_MESSAGE = 'UPDATE_VOICEMAIL_MESSAGE'

const initialState = {
  conversations: [],
  unreadConversationIds: [],
  closedConversationsData: [],
  assignedConversationsData: [],
  contacts: [],
  recentlyUpdatedConversationId: null,
  isLoadingMessages: false,
  isLoadingConversations: true,
  chatInboxes: null,
  buildingSmsPackage: null,
  invoices: null,
  highManagementUsers: [],
  voicemailMessages: [],
}

const removeDuplicate = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.channelName)) {
        tempArr.push(obj.channelName)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const uniqEntities = (currentEntities, newEntities) => {
  const filtered = currentEntities.filter(
    (entity) => newEntities.find((newEntity) => newEntity === entity) === undefined,
  )

  return [...filtered, ...newEntities]
}

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHAT_CONTACTS:
      return {
        ...state,
        contacts: action.data,
      }
    case ADD_CONVERSATION:
      return {
        ...state,
        conversations: [action.data, ...state.conversations],
      }
    case UPDATE_CONVERSATION_OR_ADD:
      const isExist = state.conversations.some(
        (conv) => conv.id === action.data.id || conv.channelName === action.data.id,
      )
      return {
        ...state,
        conversations: isExist
          ? state.conversations.map((conv) =>
              conv.id === action.data.id || conv.channelName === action.data.id
                ? {
                    ...conv,
                    ...action.data,
                  }
                : conv,
            )
          : [action.data, ...state.conversations],
      }
    case ADD_UNREAD_CONVERSATIONS:
      return {
        ...state,
        unreadConversationIds: uniqEntities(state.unreadConversationIds, [action.data]),
        recentlyUpdatedConversationId: action.data,
      }
    case ADD_CLOSED_CONVERSATIONS:
      return {
        ...state,
        closedConversationsData: state.closedConversationsData.find(
          (conversationData) => conversationData.name === action.name,
        )
          ? state.closedConversationsData
          : [...state.closedConversationsData, { name: action.name, closedAt: action.date }],
      }
    case ADD_ASSIGNED_CONVERSATIONS:
      const searchAssignedConv = state.assignedConversationsData.find(
        (conversationData) => conversationData.name === action.name,
      )
      return {
        ...state,
        assignedConversationsData: searchAssignedConv
          ? searchAssignedConv.assignee === action.assignee
            ? state.assignedConversationsData
            : [
                ...state.assignedConversationsData.filter((conv) => conv.name !== action.name),
                { name: action.name, assignee: action.assignee },
              ]
          : [...state.assignedConversationsData, { name: action.name, assignee: action.assignee }],
      }
    case REMOVE_UNREAD_CONVERSATIONS:
      return {
        ...state,
        unreadConversationIds: state.unreadConversationIds.filter(
          (conversationId) => conversationId !== action.data,
        ),
      }
    case REMOVE_ALL_UNREAD_CONVERSATIONS:
      return {
        ...state,
        unreadConversationIds: [],
      }
    case REMOVE_CLOSED_CONVERSATIONS:
      return {
        ...state,
        closedConversationsData: state.closedConversationsData.filter(
          (conversationObject) => conversationObject.name !== action.data,
        ),
      }
    case REMOVE_ASSIGNED_CONVERSATIONS:
      return {
        ...state,
        assignedConversationsData: state.assignedConversationsData.filter(
          (conversationObject) => conversationObject.name !== action.data,
        ),
      }
    case SET_CONVERSATIONS:
      return {
        ...state,
        conversations: removeDuplicate(action.data),
        recentlyUpdatedConversationId: null,
      }
    case SET_CHAT_INBOX:
      return {
        ...state,
        chatInboxes: action.data,
      }
    case SET_CUSTOM_CHAT_INBOX:
      return {
        ...state,
        customChatInbox: action.data,
      }
    case UPDATE_CHAT_INBOX:
      const updatedInboxes = state.chatInboxes.map((inbox) =>
        inbox.id === action.data.id ? { ...inbox, ...action.data } : inbox,
      )
      return {
        ...state,
        chatInboxes: updatedInboxes,
      }
    case SET_INVOICES:
      return {
        ...state,
        invoices: action.data,
      }
    case SET_BUILDING_SMS_PACK:
      return {
        ...state,
        buildingSmsPackage: action.data,
      }
    case SET_LOADING_MESSAGES:
      return {
        ...state,
        isLoadingMessages: action.data,
      }
    case SET_LOADING_CONVERSATIONS:
      return {
        ...state,
        isLoadingConversations: action.data,
      }
    case SET_HIGH_MANAGEMENT_USERS:
      return {
        ...state,
        highManagementUsers: action.data,
      }
    case SET_VOICEMAIL_MESSAGES:
      return {
        ...state,
        voicemailMessages: action.data,
      }
    case REMOVE_VOICEMAIL_MESSAGE:
      const updatedVoicemailMessages = state.voicemailMessages.filter(
        (message) => message.id !== action.data,
      )
      if (state.chatInboxes && state.chatInboxes.length) {
        const updatedInboxes = state.chatInboxes.map((inbox) => {
          const updatedInbox = { ...inbox }
          if (inbox.voicemailMessage && inbox.voicemailMessage.id === action.data) {
            updatedInbox.voicemailMessage = null
          }

          if (
            inbox.outOfOfficeVoicemailMessage &&
            inbox.outOfOfficeVoicemailMessage.id === action.data
          ) {
            updatedInbox.outOfOfficeVoicemailMessage = null
          }

          return updatedInbox
        })
        return {
          ...state,
          voicemailMessages: updatedVoicemailMessages,
          chatInboxes: updatedInboxes,
        }
      }
      return {
        ...state,
        voicemailMessages: updatedVoicemailMessages,
      }
    case ADD_VOICEMAIL_MESSAGE:
      return {
        ...state,
        voicemailMessages: [...state.voicemailMessages, action.data],
      }
    case UPDATE_VOICEMAIL_MESSAGE:
      return {
        ...state,
        voicemailMessages: state.voicemailMessages.map((message) =>
          message.id === action.data.id ? { ...message, ...action.data } : message,
        ),
      }
    default:
      return state
  }
}

const setConversations = (data) => ({
  type: SET_CONVERSATIONS,
  data,
})

const updateConversation = (data) => ({
  type: UPDATE_CONVERSATION_OR_ADD,
  data,
})

const addConversation = (data) => ({
  type: ADD_CONVERSATION,
  data,
})

const updateChatInboxes = (data) => ({
  type: UPDATE_CHAT_INBOX,
  data,
})

const addUnreadConversationIds = (data) => ({
  type: ADD_UNREAD_CONVERSATIONS,
  data,
})

const addClosedConversationIds = (name, date) => ({
  type: ADD_CLOSED_CONVERSATIONS,
  name,
  date,
})

const addAssignedConversationIds = (name, assignee) => ({
  type: ADD_ASSIGNED_CONVERSATIONS,
  name,
  assignee,
})

const removeFromUnreadConversationIds = (data) => ({
  type: REMOVE_UNREAD_CONVERSATIONS,
  data,
})

const removeAllUnreadConversationIds = () => ({
  type: REMOVE_ALL_UNREAD_CONVERSATIONS,
})

const removeClosedConversationIds = (data) => ({
  type: REMOVE_CLOSED_CONVERSATIONS,
  data,
})

const removeAssignedConversationIds = (data) => ({
  type: REMOVE_ASSIGNED_CONVERSATIONS,
  data,
})

const setHighManagementUsers = (data) => ({
  type: SET_HIGH_MANAGEMENT_USERS,
  data,
})

const setVoicemailMessages = (data) => ({
  type: SET_VOICEMAIL_MESSAGES,
  data,
})

const removeVoicemailMessage = (data) => ({
  type: REMOVE_VOICEMAIL_MESSAGE,
  data,
})

const addVoicemailMessage = (data) => ({
  type: ADD_VOICEMAIL_MESSAGE,
  data,
})

const updateVoicemailMessage = (data) => ({
  type: UPDATE_VOICEMAIL_MESSAGE,
  data,
})

export const dispatchUpdateConversation = (data) => {
  return (dispatch) => {
    return dispatch(updateConversation(data))
  }
}

export const dispatchAddConversation = (data) => {
  return (dispatch) => {
    return dispatch(addConversation(data))
  }
}

export const dispatchSetConversations = (data) => {
  return (dispatch) => {
    return dispatch(setConversations(data))
  }
}

export const dispatchSetHighManagementUsers = (data) => {
  return (dispatch) => {
    return dispatch(setHighManagementUsers(data))
  }
}

export const dispatchGetChatContacts = (data) => {
  return async (dispatch) => {
    try {
      const response = await API.getChatClients(data)
      dispatch({
        type: SET_CHAT_CONTACTS,
        data: response.data,
      })
      return response.data
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const dispatchAddUnreadConversationIds = (data) => {
  return (dispatch) => {
    return dispatch(addUnreadConversationIds(data))
  }
}

export const dispatchAddClosedConversationIds = (name, date) => {
  return (dispatch) => {
    return dispatch(addClosedConversationIds(name, date))
  }
}

export const dispatchAddAssignedConversationIds = (name, assignee) => {
  return (dispatch) => {
    return dispatch(addAssignedConversationIds(name, assignee))
  }
}

export const dispatchRemoveFromUnreadConversationIds = (data) => {
  return (dispatch) => {
    return dispatch(removeFromUnreadConversationIds(data))
  }
}

export const dispatchRemoveAllUnreadConversationIds = () => {
  return (dispatch) => {
    return dispatch(removeAllUnreadConversationIds())
  }
}

export const dispatchRemoveClosedConversationIds = (data) => {
  return (dispatch) => {
    return dispatch(removeClosedConversationIds(data))
  }
}

export const dispatchRemoveAssignedConversationIds = (data) => {
  return (dispatch) => {
    return dispatch(removeAssignedConversationIds(data))
  }
}

export const dispatchGetChatInboxes = (buildingId) => {
  return async (dispatch) => {
    try {
      const response = await API.getChatInboxes(buildingId)

      dispatch({
        type: SET_CHAT_INBOX,
        data: cloneDeep(response.data.inboxes),
      })
      dispatch({
        type: SET_BUILDING_SMS_PACK,
        data: response.data.smsPackage,
      })
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const dispatchGetCustomChatInbox = (buildingId) => {
  return async (dispatch) => {
    try {
      const response = await API.getCustomChatInbox(buildingId)

      dispatch({
        type: SET_CUSTOM_CHAT_INBOX,
        data: response.data.inbox,
      })
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const getInvoicesWithCount = (page = 1, buildingId = 0, pageSize = 50) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getInvoices(buildingId, start, pageSize)
      .then((response) => {
        dispatch({
          type: SET_INVOICES,
          data: response.data.invoices,
        })
        return Promise.resolve(response.data.count)
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

export const dispatchUpdateChatInboxes = (data) => {
  return (dispatch) => {
    return dispatch(updateChatInboxes(data))
  }
}

export const dispatchUpdateSmsPackage = (data) => {
  return (dispatch) => {
    return dispatch({
      type: SET_BUILDING_SMS_PACK,
      data,
    })
  }
}

export const dispatchSetLoadingMessages = (data) => {
  return (dispatch) => {
    return dispatch({
      type: SET_LOADING_MESSAGES,
      data,
    })
  }
}

export const dispatchSetLoadingConversations = (data) => {
  return (dispatch) => {
    return dispatch({
      type: SET_LOADING_CONVERSATIONS,
      data,
    })
  }
}

export const getVoicemailMessages = (inboxId) => {
  return async (dispatch) => {
    try {
      const response = await API.getVoicemailMessages(inboxId)
      dispatch(setVoicemailMessages(response.data))
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const deleteVoicemailMessage = (inboxId, messageId) => {
  return async (dispatch) => {
    try {
      await API.deleteVoicemailMessage(inboxId, messageId)
      dispatch(removeVoicemailMessage(messageId))
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const createVoicemailMessage = (inboxId, data) => {
  return async (dispatch) => {
    try {
      const response = await API.createVoicemailMessage(inboxId, data)
      dispatch(addVoicemailMessage(response.data))
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const updateVoicemailMessageAction = (inboxId, messageId, data) => {
  return async (dispatch) => {
    try {
      const response = await API.updateVoicemailMessage(inboxId, messageId, data)
      dispatch(updateVoicemailMessage(response.data))
    } catch (error) {
      throw new Error(error)
    }
  }
}

export const selectConversations = (state) => state.chat.conversations

export const selectUnreadConversationIds = (state) => state.chat.unreadConversationIds

export const selectClosedConversationsData = (state) => state.chat.closedConversationsData

export const selectAssignedConversationsData = (state) => state.chat.assignedConversationsData

export const selectChatContacts = (state) => state.chat.contacts

export const selectChatInboxes = (state) => state.chat.chatInboxes

export const selectCustomChatInbox = (state) => state.chat.customChatInbox

export const selectInvoices = (state) => state.chat.invoices

export const selectHighManagementUsers = (state) => state.chat.highManagementUsers

export const selectBuildingSmsPackage = (state) => state.chat.buildingSmsPackage

export const selectRecentlyUpdatedConvId = (state) => state.chat.recentlyUpdatedConversationId

export const isLoadingMessages = (state) => state.chat.isLoadingMessages

export const isLoadingConversations = (state) => state.chat.isLoadingConversations

export const selectVoicemailMessages = (state) => state.chat.voicemailMessages

export default chatReducer
